import React from 'react';

import { useURLQuery } from 'components/hooks';
import { sanitizeInternalUrl } from 'lib/redirect';

import UnlockCore from './UnlockCore';

function UnlockPage() {
  const locationQuery = useURLQuery();
  const unsafeAfterUnlockGoTo = locationQuery.get('afterUnlock');
  const afterUnlockGoTo = unsafeAfterUnlockGoTo
    ? sanitizeInternalUrl(unsafeAfterUnlockGoTo)
    : undefined;

  return (
    <UnlockCore
      afterUnlockGoTo={afterUnlockGoTo || '/'}
      keepWalletUntilSuccess={false}
      layout="page"
    />
  );
}

export default UnlockPage;
